import { getAssetPath } from '@stencil/core';

import wcShared from '@web-components/shared';

import { InitStore } from './Stores/init-store';
import { Store } from './Stores/store';

class AvatarsBotClass {
  beep: IWCAvatarsBot[] = [
    // {
    //     name: 'Beepot',
    //     url: 'Beepot.svg'
    // },
    // {
    //     name: 'Beeptus',
    //     url: 'Beeptus.svg'
    // },
    // {
    //     name: 'Extra-Beep',
    //     url: 'Extrabeep.svg'
    // },
    // {
    //     name: 'Magic-Beep',
    //     url: 'Magicbeep.svg'
    // },
    // {
    //     name: 'Shinobeep',
    //     url: 'Ninbeep.svg'
    // },
    // {
    //     name: 'Shinobeep',
    //     url: 'Ninbeep2.svg'
    // },
    // {
    //     name: 'Son Gobeep',
    //     url: 'Sangobeep.svg'
    // },
    // {
    //     name: 'Zombeep',
    //     url: 'Zombeep.svg'
    // },
    // {
    //     name: 'Zombeep',
    //     url: 'Zombeep2.svg'
    // },
    {
      name: 'Support Infomaniak',
      url: 'support_infomaniak.svg',
    },
  ];

  user: IWCAvatarsBot[] = [
    {
      name: wcShared?.translate('Alien'),
      url: getAssetPath('./../assets/icons/icon-space-users/alien.svg'),
    },
    {
      name: wcShared?.translate('Alien'),
      url: getAssetPath('./../assets/icons/icon-space-users/alien_2.svg'),
    },
    {
      name: wcShared?.translate('Space'),
      url: getAssetPath('./../assets/icons/icon-space-users/space.svg'),
    },
    {
      name: wcShared?.translate('Space'),
      url: getAssetPath('./../assets/icons/icon-space-users/space_2.svg'),
    },
    {
      name: wcShared?.translate('Invader'),
      url: getAssetPath('./../assets/icons/icon-space-users/invader.svg'),
    },
    {
      name: wcShared?.translate('Invader'),
      url: getAssetPath('./../assets/icons/icon-space-users/invader_2.svg'),
    },
  ];

  initAvatar() {
    // Init for bot avatar
    if (wcShared?.store?.utils?.getCookie('IkChatBotBeep')) {
      const number = wcShared?.store?.utils?.getCookie('IkChatBotBeep');
      if (number > this.beep.length - 1) {
        const number = wcShared?.store?.utils?.getRandomNumber(0, this.beep.length - 1);
        wcShared?.store?.utils?.setCookie('IkChatBotBeep', number, null);
      }
      Store?.set('beepAvatar', this.beep[number]);
    } else {
      const number = wcShared?.store?.utils?.getRandomNumber(0, this.beep.length - 1);
      wcShared?.store?.utils?.setCookie('IkChatBotBeep', number, null);
      Store?.set('beepAvatar', this.beep[number]);
    }

    if (Boolean(InitStore?.get('init')?.user?.avatar_url)) {
      Store?.set('userAvatar', {
        name: InitStore?.get('init')?.user?.display_name,
        url: InitStore?.get('init')?.user?.avatar_url,
      });
    } else {
      // Init for user avatar
      if (wcShared?.store?.utils?.getCookie('IkChatBotUser')) {
        const number = wcShared?.store?.utils?.getCookie('IkChatBotUser');
        Store?.set('userAvatar', this.user[number]);
      } else {
        const number = wcShared?.store?.utils?.getRandomNumber(0, this.user.length - 1);
        wcShared?.store?.utils?.setCookie('IkChatBotUser', number, null);
        Store?.set('userAvatar', this.user[number]);
      }
    }
  }
}

export default new AvatarsBotClass();
